module.exports = __webpack_public_path__ + "assets/img/elm.ea348af.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nav/elm.jpeg
// module id = 9HL/
// module chunks = 1